// Copilot AI API client
import { api } from './api';

export const copilotAPI = {
  // Send a natural language message → returns parsed intent + preview
  chat: (message, sessionId) =>
    api.post('/copilot/chat', { message, session_id: sessionId }),

  // Execute a previously-parsed intent (after user confirmation)
  execute: (intent, args) =>
    api.post('/copilot/execute', { intent, args }),

  // Current month usage / quota
  getUsage: () => api.get('/copilot/usage'),
};
